import { BaseViewStore } from "core/stores";
import { observable, action } from "mobx";
import { WoundService } from "../../wound-order/services";
import { toDateObject } from "core/utils";
class DispensingOrderReviewViewStore extends BaseViewStore {
    @observable accessor wounds = [];
    @observable accessor isSummaryAvailable = false;    

    constructor(rootStore) {
        super(rootStore, {
            name: "edit-dispensing-order",
            id: rootStore.routerStore.routerState.params.woundOrderId,
            authorization: "portalSection.update",
        });

        this.loadWounds()
    }

    async loadWounds(){
        const woundService = new WoundService(
            this.rootStore.application.baasic.apiClient
        );

        let response = await woundService.find({
            sort: "dateCreated|asc",
            embed: "WoundDressings",
            woundOrderId:
                this.rootStore.routerStore.routerState.params.woundOrderId,
        });

        if (response && response.data && response.data.item) {
            this.wounds.replace(
                response.data.item.map((item) => ({
                    ...item,
                    initialAssessmentDate:
                        item.initialAssessmentDate &&
                        item.initialAssessmentDate.construcotr != Date
                            ? toDateObject(item.initialAssessmentDate)
                            : null,
                    dispensingOrderDate:
                        item.dispensingOrderDate &&
                        item.dispensingOrderDate.construcotr != Date
                            ? toDateObject(item.dispensingOrderDate)
                            : null,
                }))
            );
        }
        this.checkDispensingOrderReviewStatus();
    }

    @action.bound
    async goBack() {
        this.rootStore.routerStore.goBack();
    }

    checkDispensingOrderReviewStatus() {
        let allCompleted = this.wounds.every(
            (wound) => wound.hasCompletedWoundDispensingOrder === true
        );
        if (allCompleted) {
            this.isSummaryAvailable = true;
        }
    }

    @action.bound
    async submitWoundDispensingOrder(wound, flag) {
        if (wound.initialAssessmentDate === null ) {
            this.rootStore.notificationStore.error(
                "Can't save order without initial assessment date."
            );
            return;
        }
        if(wound.dispensingOrderDate == null && !wound.isMissingDispensingOrder)
        {
            this.rootStore.notificationStore.error(
                "Can't save without Dispensing Order Date"
            );
            return;
        }
        const woundService = new WoundService(
            this.rootStore.application.baasic.apiClient
        );
        wound.hasCompletedWoundDispensingOrder = flag;
        await woundService.validateDispensingOrder({
            woundId: wound.id,
            dispensingOrderDate: wound.dispensingOrderDate || null,
            isMissingDispensingOrder: wound.isMissingDispensingOrder || false,
            hasCompletedWoundDispensingOrder: flag,
            initialAssessmentDate: wound.initialAssessmentDate || null,
            woundDressingDispensingOrders: wound.woundDressings.map(
                (order) => ({
                    woundDressingId: order.id,
                    isDressingNotIncludedInOrder:
                        order.isDressingNotIncludedInOrder || false,
                    isFocNotIncludedInOrder:
                        order.isFocNotIncludedInOrder || false,
                    isApplicationTypeNotIncludedInOrder:
                        order.isApplicationTypeNotIncludedInOrder || false,
                })
            ),
        });

        this.checkDispensingOrderReviewStatus();
    }

    @action.bound
    async proceedToSummary() {
        const woundService = new WoundService(
            this.rootStore.application.baasic.apiClient
        );
        await woundService.calculateDispensingOrder(this.wounds.map(wound => wound.id));
        this.rootStore.routerStore.goTo(
            "master.app.main.wound-order.add-wound-dressing",
            {
                id: this.rootStore.routerStore.routerState.params.woundOrderId,
                hasCompletedCalculation: true,
            }
        );
    }
}

export default DispensingOrderReviewViewStore;
